import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiCreateEvidenceRequestRequest,
  DefaultApiPostCancelRequestForEvidenceRequestRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const createEvidenceRequest = async (
  instance: AxiosInstance,
  params: DefaultApiCreateEvidenceRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).createEvidenceRequest(params)
}

export const postCancelRequestForEvidenceRequest = async (
  instance: AxiosInstance,
  params: DefaultApiPostCancelRequestForEvidenceRequestRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postCancelRequestForEvidenceRequest(params)
}

// Do Not Remove this line ===@import api client===
